export const cartLine = `
id
quantity
merchandise {
  ... on ProductVariant {
    id
    title
    sku
    available: availableForSale
    priceV2 {
      amount
    }
    compareAtPriceV2 {
      amount
    }
    product {
      ... on Product {
        title
        handle
        tags
        images(first: 1) {
          edges {
            node {
              src
              altText
              height
              width
            }
          }
        }
      }
    }
  }
}
`;

export const cart = `
checkoutUrl
id
totalQuantity
cost {
  subtotalAmount {
    amount
    currencyCode
  }
}
lines(first: 50) {
  edges {
    node {
      ${cartLine}
    }
  }
}
`;

export const product = `
  available: availableForSale
  featuredImage {
    altText
    url
  }
  handle
  description
  descriptionHtml
  id
  productType
  title
  tags
  productSubtitle: metafield(namespace: "custom_fields", key: "subtitle") {
    value
  }
  fit: metafield(namespace: "custom_fields", key: "fit") {
    value
  }
  details: metafield(namespace: "custom_fields", key: "details") {
    value
  }
  care: metafield(namespace: "custom_fields", key: "care") {
    value
  }
  materials: metafield(namespace: "custom_fields", key: "materials") {
    value
  }
  media(first: 10) {
    edges {
      cursor
      node {
        alt
        mediaContentType
        previewImage {
          altText
          originalSrc
          transformedSrc(maxWidth: 900, maxHeight: 1200, preferredContentType: JPG)
        }
        ... on ExternalVideo {
          id
          alt
          host
          embedUrl
          embeddedUrl
          originUrl
        }
        ... on MediaImage {
          id
          image {
            src
            altText
            height
            width
          }
        }
        ... on Video {
          id
          sources {
            format
            url
            mimeType
          }
        }
      }
    }
  }
  variants(first: 20) {
    edges {
      node {
        id
        title
        quantityAvailable
        available: availableForSale
        currentlyNotInStock
        price {
          amount
        }
        compareAtPrice {
          amount
        }
        selectedOptions {
          name
          value
        }
        image {
          altText
          url
        }
        sku
        modelImages: metafield(namespace: "custom", key: "model_images") {
          references(first: 20) {
            nodes {
              ... on MediaImage {
                alt
                id
                mediaContentType
                previewImage {
                  altText
                  originalSrc
                  transformedSrc
                }
                image {
                  src
                  altText
                  height
                  width
                }
              }
            }
          }
        }
        model: metafield(namespace: "custom", key: "model") {
          reference {
            ... on Metaobject {
              fields {
                value
                key
              }
            }
          }
        }
        preorder: metafield(namespace: "custom", key: "preorder") {
          value
        }
        preOrderDisclaimer: metafield(namespace: "custom", key: "pre_order_disclaimer") {
          value
        }
        maxPreorderInventory: metafield(namespace: "custom", key: "max_preorder_inventory") {
          value
        }
      }
    }
  }
  options {
    id
    name
    values
  }
`;
